/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Seller_LoginInputs */

const cs_sreality_seller_login = /** @type {(inputs: Sreality_Seller_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seznam login (e-mail)`)
};

const en_sreality_seller_login = /** @type {(inputs: Sreality_Seller_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seznam login (email)`)
};

/**
* | output |
* | --- |
* | "Seznam login (email)" |
*
* @param {Sreality_Seller_LoginInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_seller_login = /** @type {((inputs?: Sreality_Seller_LoginInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Seller_LoginInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_seller_login(inputs)
	return cs_sreality_seller_login(inputs)
});